import React from "react";
import ISOHeader50001 from "../../../components/ISO Certificates/ISO 50001-2011/ISOHeader50001";
import ISOCOntent50001 from "../../../components/ISO Certificates/ISO 50001-2011/ISOCOntent50001";
import ISOServiceIndia9001 from "../../../components/ISO Certificates/ISO Common/ISOServiceIndia9001";
import ISOSpecifications from "../../../components/ISO Certificates/ISO 50001-2011/ISOSpecification";

const ISO500012011 = () => {
  return (
    <div>
      {" "}
      <ISOHeader50001 />
      <ISOCOntent50001 />
      <ISOServiceIndia9001 />
      <ISOSpecifications />
    </div>
  );
};

export default ISO500012011;
